var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sh_empty_container",class:_vm.customClass},[_c('el-empty',_vm._b({staticClass:"sh_empty",attrs:{"description":_vm.$attrs.description || '暂无数据'}},'el-empty',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }